import React, { useState } from "react";
import EnterCodeModel from "../EntercodeModel";

function ForgotPasseordModel({ showModal, onClose }) {
  const [showEnterCodeModal, setShowEnterCodeModal] = useState(false);
  const handleOpenModle = (e) => {
    e.preventDefault();
    setShowEnterCodeModal(true);
  };

  const handleCloseModal = () => {
    setShowEnterCodeModal(false);
  };

  return (
    <div>
      <div
        className={`fixed inset-0 flex items-end justify-center  ${
          showModal ? "block" : "hidden"
        }`}
      >
        <div
          className="fixed inset-0 bg-black opacity-50 "
          onClick={onClose}
        ></div>
        <div className="bg-white dark:bg-[#000]  w-full md:w-1/2  p-5  pb-10 shadow-lg transform transition-transform duration-300  rounded-t-[56px]">
          <div className="flex justify-center ">
            <div className="border-2 border-[#5D5FEF] w-32 mt-3 mb-8"></div>
          </div>

          <div className="flex flex-col items-center  px-12  mb-10">
            <div className="space-y-3">
              <p className="font-[600] text-[30px] mt-10">Forgot Password</p>
              <p className=" text-[20px] font-semibold">
                Enter your email for the verification process, We will send 4
                digits code to your email.
              </p>
              <div>
                <p className="font-[400] text-[20px] mb-3 mt-14">Email</p>

                <div
                  className="w-99 boder border-[#D9D9D] rounded-[25px] bg-[#D9D9D9]"
                >
                  <input
                    type="email"
                    className=" w-80  focus:outline-none boder p-4  rounded-[25px] dark:text-[#000]  bg-[#D9D9D9] px-2"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center   px-12 ">
            <div className="">
              <button
                onClick={handleOpenModle}
                className="w-80 boder border-[#D9D9D] rounded-[25px] bg-[#2A71E8] p-5 text-white  mb-10 text-[15px] "
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <EnterCodeModel
        onCloseEnterCodeModal={handleCloseModal}
        showEnterCodeModal={showEnterCodeModal}
      />
    </div>
  );
}

export default ForgotPasseordModel;
